import BaseModel from '../BaseModel';

export default class OfficePhoto extends BaseModel {
  static entity = 'officePhotos';

  static primaryKey = 'id';

  static fields() {
    return {
      id: this.attr(null),
      companyId: this.attr(null),
      preview: this.attr(null),
      photo: this.attr(null),
    };
  }

  static apiConfig = {
    actions: {
      async store(companyId, payload) {
        const result = await this.post(`companies/${companyId}/office-photos`, payload);
        // eslint-disable-next-line no-param-reassign
        result.response.data.data.forEach((p) => { p.companyId = companyId; });
        result.save();
        return result;
      },
      destroy(id) {
        return this.delete(`companies/office-photo/${id}`, { delete: id });
      },
    },
  }
}
